"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const NativeSelect_1 = __importDefault(require("../../../common/js/atoms/NativeSelect"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const array_1 = require("../../../common/js/helper/array");
const noop_1 = require("../../../common/js/helper/noop");
const translation_1 = require("../../../common/js/helper/translation");
const Paths_1 = require("../../constants/Paths");
const DataLayerActions_1 = __importDefault(require("../../enums/DataLayerActions"));
const DataLayerLabels_1 = __importDefault(require("../../enums/DataLayerLabels"));
const address_1 = require("../../helper/address");
const dataLayer_1 = require("../../helper/dataLayer");
const history_1 = require("../../helper/history");
const MassiveCompany_1 = __importDefault(require("../../stores/MassiveCompany"));
const ShopwareCart_1 = __importDefault(require("../../stores/ShopwareCart"));
const ShopwareContext_1 = __importDefault(require("../../stores/ShopwareContext"));
const ShopwareShippingMethods_1 = __importDefault(require("../../stores/ShopwareShippingMethods"));
const SelectAddress_1 = __importDefault(require("../SelectAddress"));
const ShopCheckoutLayout_1 = __importDefault(require("../ShopCheckoutLayout"));
const ShopCheckoutRadio_1 = __importDefault(require("../ShopCheckoutRadio"));
class ShopCheckoutShipping extends react_1.default.Component {
    customerIdReactionDisposer;
    customerIdInputRef = react_1.default.createRef();
    promiseUpdateCustomerId = Promise.resolve();
    loadingCounter = 0;
    isUpdatingCustomerId = false;
    initialLoading = true;
    customerId = '';
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            loadingCounter: mobx_1.observable,
            isUpdatingCustomerId: mobx_1.observable,
            initialLoading: mobx_1.observable,
            customerId: mobx_1.observable,
            addresses: mobx_1.computed,
            addressOptions: mobx_1.computed,
            billingAddress: mobx_1.computed,
            shippingAddress: mobx_1.computed,
            defaultAddress: mobx_1.computed,
            isLoading: mobx_1.computed,
            isButtonDisabled: mobx_1.computed,
            updateCustomerId: mobx_1.action.bound,
            loadShippingMethods: mobx_1.action.bound,
            onChangeCustomerId: mobx_1.action.bound,
        });
    }
    get addresses() {
        return (0, address_1.getAddressesOfCompany)(MassiveCompany_1.default.company);
    }
    get addressOptions() {
        return Object.values(this.addresses)
            .filter((address) => address !== undefined && address.name !== undefined)
            .reduce((options, address) => {
            return address.id
                ? {
                    ...options,
                    [address.id]: address.name,
                }
                : options;
        }, {});
    }
    get billingAddress() {
        return (0, address_1.getCompanyAddressById)(ShopwareContext_1.default.currentBillingAddressId, MassiveCompany_1.default.company);
    }
    get shippingAddress() {
        return (0, address_1.getCompanyAddressById)(ShopwareContext_1.default.currentShippingAddressId, MassiveCompany_1.default.company);
    }
    get defaultAddress() {
        return (0, array_1.first)(Object.values((0, address_1.getAddressesOfCompany)(MassiveCompany_1.default.company)));
    }
    get isLoading() {
        return this.initialLoading || this.loadingCounter > 0;
    }
    get isButtonDisabled() {
        return ((this.isLoading && !this.isUpdatingCustomerId) ||
            (ShopwareShippingMethods_1.default.shippingMethodList?.length ?? 0) <= 0);
    }
    componentDidMount() {
        const checkoutReset = this.props.checkoutReset;
        (0, dataLayer_1.pushToDataLayer)({
            action: DataLayerActions_1.default.checkoutProgress,
            [DataLayerLabels_1.default.eventLabel]: (0, translation_1.t)('shop_checkout_page.stepper.shipping'),
        });
        ShopwareContext_1.default.loadContext()
            .then(() => MassiveCompany_1.default.loadCompany())
            .then((company) => {
            if (this.billingAddress && this.shippingAddress) {
                return;
            }
            return ShopwareContext_1.default.setAddresses(company?.defaultBillingMassiveAddressId ?? this.defaultAddress?.id, company?.defaultShippingMassiveAddressId ??
                company?.defaultBillingMassiveAddressId ??
                this.defaultAddress?.id);
        })
            .then(() => this.loadShippingMethods().catch(noop_1.noop))
            .then(() => {
            return ShopwareCart_1.default.loadCart(noop_1.noop, !checkoutReset);
        })
            .finally((0, mobx_1.action)(() => (this.initialLoading = false)));
        this.customerIdReactionDisposer = (0, mobx_1.reaction)(() => ShopwareContext_1.default.contextExtension?.massiveShippingMethodCustomerId, (customerId) => {
            this.customerId = customerId ?? '';
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        this.customerIdReactionDisposer?.();
    }
    render() {
        return (react_1.default.createElement(ShopCheckoutLayout_1.default, { title: (0, translation_1.t)('shop_checkout_shipping_page.page_title'), submitElement: this.renderSubmitElement(), loading: ShopwareCart_1.default.isLoading },
            react_1.default.createElement("h3", { className: "znd-shop-checkout-shipping__headline t-headline-3" }, (0, translation_1.t)(ShopwareCart_1.default.hasProductWithCategorySoftware
                ? 'shop_checkout_shipping_page.billing_information'
                : 'shop_checkout_shipping_page.shipping_information')),
            Object.values(this.addresses).length <= 0 || this.initialLoading ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "ml-auto mr-auto" })) : (react_1.default.createElement("div", { className: "znd-shop-checkout-shipping__addresses d-flex flex-column flex-md-row flex-wrap" },
                !ShopwareCart_1.default.hasProductWithCategorySoftware ? (react_1.default.createElement("div", { className: "znd-shop-checkout-shipping__addresses__column" },
                    react_1.default.createElement(SelectAddress_1.default, { subhead: (0, translation_1.t)('shop_checkout_shipping_page.shipping_address.subhead'), onChange: (0, mobx_1.action)((value) => {
                            this.loadingCounter++;
                            return ShopwareContext_1.default.setShippingAddress(value)
                                .then(this.loadShippingMethods)
                                .catch(noop_1.noop)
                                .then(() => ShopwareCart_1.default.loadCart())
                                .then(noop_1.noop)
                                .finally((0, mobx_1.action)(() => {
                                this.loadingCounter--;
                            }));
                        }), disabled: this.isLoading, address: this.shippingAddress, options: this.addressOptions, placeholder: (0, translation_1.t)('shop_checkout_shipping_page.shipping_address.choose') }))) : null,
                react_1.default.createElement("a", { id: "billing-address" }),
                react_1.default.createElement("div", { id: "billing-address", className: (0, classnames_1.default)('znd-shop-checkout-shipping__addresses__column', {
                        'ml-0': ShopwareCart_1.default.hasProductWithCategorySoftware,
                    }) },
                    react_1.default.createElement(SelectAddress_1.default, { subhead: (0, translation_1.t)('shop_checkout_shipping_page.billing_address.subhead'), onChange: (0, mobx_1.action)((value) => {
                            this.loadingCounter++;
                            return ShopwareContext_1.default.setBillingAddress(value)
                                .then(() => ShopwareCart_1.default.loadCart())
                                .then(noop_1.noop)
                                .finally((0, mobx_1.action)(() => {
                                this.loadingCounter--;
                            }));
                        }), disabled: this.isLoading, address: this.billingAddress, options: this.addressOptions, placeholder: (0, translation_1.t)('shop_checkout_shipping_page.billing_address.choose') })))),
            react_1.default.createElement("a", { id: "shipping-method" }),
            react_1.default.createElement("div", { className: "znd-shop-checkout-shipping__change-address-text mb-4" }, (0, translation_1.t)('shop_checkout_shipping_page.change_address_text')),
            react_1.default.createElement("h3", { className: "znd-shop-checkout-shipping__headline t-headline-3" }, (0, translation_1.t)('shop_checkout_shipping_page.shipping_method')),
            this.initialLoading ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "ml-auto mr-auto" })) : (react_1.default.createElement("div", { className: "znd-shop-checkout-shipping__shipping-methods" }, ShopwareShippingMethods_1.default.shippingMethodList
                ?.slice()
                .sort(
            // TODO: Use both positions for BC. Remove "massiveShippingMethod" after planed production release in June 2022.
            (a, b) => (a.position ?? a.extensions?.massiveShippingMethod?.position ?? 0) -
                (b.position ?? b.extensions?.massiveShippingMethod?.position ?? 0))
                .map((shippingMethod) => (react_1.default.createElement(ShopCheckoutRadio_1.default, { key: shippingMethod.id, groupName: 'shipping-method', selectableMethod: shippingMethod, checked: ShopwareContext_1.default.currentShippingMethod?.id === shippingMethod.id, disabled: this.isLoading, onChange: (0, mobx_1.action)((value) => {
                    this.loadingCounter++;
                    return ShopwareContext_1.default.setShippingMethod(value, '')
                        .then(() => this.loadShippingMethodServices().catch(noop_1.noop))
                        .then(() => ShopwareCart_1.default.loadCart())
                        .then(noop_1.noop)
                        .finally((0, mobx_1.action)(() => this.loadingCounter--));
                }), additionalFields: this.renderAdditionalShippingMethodFields(shippingMethod) })))))));
    }
    renderSubmitElement() {
        return (react_1.default.createElement(Button_1.default, { className: "znd-shop-checkout-shipping__button ml-auto", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('shop_checkout_shipping_page.submit_button'), onClick: () => {
                this.promiseUpdateCustomerId.then(() => (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CHECKOUT_PAYMENT));
            }, disabled: this.isButtonDisabled }));
    }
    renderAdditionalShippingMethodFields(shippingMethod) {
        return [this.renderServiceSelection(shippingMethod), this.renderCustomerField(shippingMethod)];
    }
    renderServiceSelection(shippingMethod) {
        const shippingMethodType = shippingMethod.extensions?.massiveShippingMethod?.type ?? null;
        const services = ShopwareShippingMethods_1.default.getShippingMethodServices(shippingMethod);
        const hasServices = (services?.length ?? 0) > 0;
        const serviceOptions = services?.map((service) => ({
            value: service.code,
            label: service.description ?? '',
        })) ?? [];
        return hasServices ? (react_1.default.createElement(NativeSelect_1.default, { className: "znd-shop-checkout-shipping__service-input", key: "serviceSelection", placeholder: (0, translation_1.t)('shop_checkout_shipping_page.ups.services.placeholder'), options: serviceOptions, value: ShopwareContext_1.default.currentShippingMethodService ?? '', onChange: (0, mobx_1.action)((value) => {
                this.loadingCounter++;
                ShopwareContext_1.default.setShippingMethodServiceCode(value, shippingMethodType)
                    .then(() => Promise.all([ShopwareContext_1.default.loadContext(), ShopwareCart_1.default.loadCart()]))
                    .finally((0, mobx_1.action)(() => {
                    this.loadingCounter--;
                }));
            }), disabled: this.isLoading })) : null;
    }
    renderCustomerField(shippingMethod) {
        return shippingMethod.extensions?.massiveShippingMethod?.enableCustomerId ? (react_1.default.createElement("input", { ref: this.customerIdInputRef, key: "customerId", type: "text", className: "form-control znd-shop-checkout-shipping__customer-id-input", value: this.customerId, placeholder: (0, translation_1.t)('shop_checkout_shipping_page.customer_id_placeholder'), disabled: this.isLoading, onChange: this.onChangeCustomerId, onBlur: this.onBlurCustomerId })) : null;
    }
    onChangeCustomerId(event) {
        this.customerId = event.target.value.replace(/[^a-z0-9]/gi, '').trim();
    }
    onBlurCustomerId() {
        this.updateCustomerId();
    }
    updateCustomerId() {
        this.loadingCounter++;
        this.isUpdatingCustomerId = true;
        this.promiseUpdateCustomerId = this.promiseUpdateCustomerId
            .then(() => ShopwareContext_1.default.setMassiveShippingMethodCustomerId(this.customerId)
            .then(() => ShopwareCart_1.default.loadCart())
            .then(noop_1.noop)
            .finally((0, mobx_1.action)(() => {
            this.loadingCounter--;
            this.isUpdatingCustomerId = false;
        })))
            .catch(noop_1.noop);
    }
    loadShippingMethods() {
        this.loadingCounter++;
        return ShopwareShippingMethods_1.default.loadShippingMethods()
            .then(() => {
            const shippingMethods = ShopwareShippingMethods_1.default.shippingMethodList ?? [];
            const hasCurrentShippingMethod = shippingMethods.findIndex(this.isSelectedShippingMethodValid) >= 0;
            // Set valid shipping method, if previously selected is not valid anymore.
            const firstShippingMethod = (0, array_1.first)(ShopwareShippingMethods_1.default.shippingMethodList ?? []);
            if (!hasCurrentShippingMethod && !!firstShippingMethod) {
                return ShopwareContext_1.default.setShippingMethod(firstShippingMethod.id);
            }
        })
            .then(this.loadShippingMethodServices)
            .finally((0, mobx_1.action)(() => {
            this.loadingCounter--;
        }));
    }
    loadShippingMethodServices() {
        const shippingMethod = ShopwareContext_1.default.currentShippingMethod;
        if (!shippingMethod) {
            return Promise.resolve();
        }
        return ShopwareShippingMethods_1.default.loadShippingMethodServices(shippingMethod).then(() => {
            const services = ShopwareShippingMethods_1.default.getShippingMethodServices(shippingMethod) ?? [];
            const selectedService = services.find((service) => service.code === ShopwareContext_1.default.currentShippingMethodService);
            const firstService = (0, array_1.first)(services);
            if (!selectedService) {
                return ShopwareContext_1.default.setShippingMethodServiceCode(firstService?.code ?? null, firstService?.type ?? null);
            }
        });
    }
    isSelectedShippingMethodValid(method) {
        return !!ShopwareContext_1.default.currentShippingMethod?.id && ShopwareContext_1.default.currentShippingMethod?.id === method.id;
    }
}
__decorate([
    bind_decorator_1.default
], ShopCheckoutShipping.prototype, "renderSubmitElement", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutShipping.prototype, "renderAdditionalShippingMethodFields", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutShipping.prototype, "renderServiceSelection", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutShipping.prototype, "renderCustomerField", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutShipping.prototype, "onBlurCustomerId", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutShipping.prototype, "loadShippingMethodServices", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutShipping.prototype, "isSelectedShippingMethodValid", null);
exports.default = (0, mobx_react_1.observer)(ShopCheckoutShipping);
